<template>
    <div id="store-home">
        <!--banner-->
        <template v-if="banner.length === 3">
            <div class="banner multiple">
                <img v-for="item in banner" :src="item.imgUrl | urlProtocol" alt="">
            </div>
        </template>
        <template v-else>
            <div class="banner">
                <img src="../assets/store_top_default.jpg" alt="">
            </div>
        </template>
        <div class="store-intro">
            <div class="store-l">
                <h2 class="store-h" :class="{'cloud-type': store.storeType === '1'}">
                    {{store.name}}
                    <span v-if="store.storeAttentionCount">{{store.storeAttentionCount}} <i>人关注</i></span>
                </h2>
                <span class="store-address">{{store.address}}</span>
            </div>
            <div class="store-r" name="o2o_store_iPhone_01">
                <a :href="store.tel"></a>
            </div>
        </div>

        <div class="store-person" :class="{single: listPerson.length === 1}" v-if="listPerson.length > 0">
            <h2>门店服务</h2>
            <div :class="{'hd-scroll': listPerson.length !== 1}" id="hd-scroll">
                <div class="list-scroll">
                    <ul>
                        <li v-for="item in listPerson">
                            <h3>{{item.type}}</h3>
                            <div class="list-l" :class="item.icon">
                                <img :src="item.img | urlProtocol" alt="">
                            </div>
                            <div class="list-c">
                                <div class="h-wrapper">
                                    <h4>{{item.name}}</h4>
                                    <span class="service">已服务<i>{{item.num}}</i>人</span>
                                </div>
                                <span class="intro">“{{item.intro}}”</span>
                            </div>
                            <div class="list-r" name="o2o_store_guide_01">
                                <a :href="item.weeklyTopGuiderUrl">预约</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="store-act" v-if="storeActivityList.length > 0">
            <h2 @touchstart="dca">精彩活动</h2>
            <ul>
                <li v-for="item in storeActivityList" name="o2o_store_activety_01">
                    <div class="store-l">
                        <a :href="item.activityUrl">
                            <img :src="item.activePicUrl | urlProtocol" alt="">
                            <span>{{item.activityMsg}}</span>
                        </a>
                    </div>
                    <div class="store-r">
                        <a :href="item.activityUrl">
                            <h2 :class="item.activeType">{{item.title}}</h2>
                            <span>{{item.activityDesc}}</span>
                            <span>时间: {{item.showStartTime}}-{{item.showEndTime}}</span>
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

    import CONF from '@/app.conf.json';
    import Server from '../services/Entrance';
    import {Util} from '../commons/util'

    export default {
        name: 'Detail',
        data () {
            return {
                banner: [],
                store: {
                    name: '',
                    address: '',
                    storeAttentionCount: 0,
                    tel: ''
                },
                listPerson: [],
                storeActivityList: []
            }
        },

        // 生命周期钩子
        mounted () {


            setTimeout(() => {

                if (this.listPerson.length > 1) {
                    $.loadMod(MOD_URL.iscrollLite).done(function () {

                        let oListScroll = $('.list-scroll'),
                            UA = window.navigator.userAgent;

                        // 这里的实现不太好
                        oListScroll.css({width: oListScroll.find('li').length * (6.74 + 0.3) - 0.3 + 0.48 + 'rem'});
                        new IScroll('#hd-scroll', {
                            scrollX: true,
                            scrollY: false,
                            tap: true,
                            useTransform: (UA.match(/(MI|vivo|MX);?/i) && UA.match(/(SNEBUY-APP);?/i)) ? false : true,
                            eventPassthrough: true
                        });
                    });
                }
                Util.saCustomInit('', '', 'http://c.m.suning.com/sidesun-index.html', '');
            }, 500);
        },
        beforeRouteEnter(to, from, next) {

            let _this,
                urlParams = to.params,
                queryStorePromise = Server.index.queryStoreByCode(urlParams.storeCode),
                queryStoreActPromise = Server.index.queryStoreActByCode(urlParams.storeCode),
                iconArr = ['1分购','促销','大促','动态','活动','课堂','新品','报名'];



            Promise.all([queryStorePromise, queryStoreActPromise]).then(([storeData, actData]) => {


                console.log('storeData', storeData);
                console.log('actData', actData);

                next(vm => {
                    _this = vm;
                    let storeHeadPhotoList = storeData.storeHeadPhotoList,
                        storeInfo = storeData.storeInfo,
                        listPerson = [],
                        typeMap = {
                            "guideInfo": "门店导购",
                            "uServantInfo": "手机维修",
                            "financialServantInfo": "理财顾问",
                            "childServantInfo": "育婴顾问"
                        };

                    // 少于三张显示默认图
                    if (storeHeadPhotoList.length < 3) {

                        vm.banner.push({
                            imgUrl: '12'
                        });
                    } else {

                        vm.banner = storeHeadPhotoList.slice(0, 3);
                    }

                    // 门店信息
                    vm.store.name = storeInfo.name;
                    vm.store.address = storeInfo.address;
                    vm.store.storeAttentionCount = storeData.storeAttentionCount;
                    vm.store.tel = 'tel:' + storeInfo.telephone.split(';')[0];
                    vm.store.storeType = storeInfo.storeType;
                    document.title = storeInfo.name;

                    // 导购信息
                    for (let key in typeMap) {

                        let intro = storeData[key];
                        if(intro) {

                            listPerson.push({
                                icon: key,
                                type: typeMap[key],
                                name: intro.guideName,
                                intro: intro.introduction,
                                img: intro.guidePhoto,
                                num: intro.orderNum,
                                weeklyTopGuiderUrl: intro.weeklyTopGuiderUrl
                            });
                        }
                    }
                    vm.listPerson = listPerson;


                    function queryTypeIndex(val) {

                        return 'icon-' + iconArr.indexOf(val)
                    }

                    // 活动信息
                    let storeActivityListTmp = [],
                        storeActivityList = actData.storeActivityList;

                    for (let i = 0; i < storeActivityList.length; i++) {

                        let act = storeActivityList[i];

                        storeActivityListTmp.push({
                            activePicUrl: act.activePicUrl,
                            activityMsg: act.activityMsg,
                            title: act.title,
                            showStartTime: act.showStartTime,
                            showEndTime: act.showEndTime,
                            activityDesc: act.activityDesc,
                            activityUrl: act.activityUrl || CONF.otherPage.sideSuning + act.activityCode,
                            activeType: queryTypeIndex(act.activeType)
                        });
                    }

                    vm.storeActivityList = storeActivityListTmp;

                });
            })
        },
        methods: {

            dca(event) {
                console.log(event);
            }
        }
    }
</script>

<style scoped>

    #store-home {
        width: 100%;
        height: auto;
    }
    .banner {
        height: 250px;
        overflow: hidden;
        width: 100%;

        img {
            width: 100%;
            height: 100%;
            overflow: hidden;
            display: block;
        }

        &.multiple {

            img {
                width: 33.33333%;
                float: left;
                border: 2px solid #fff;
                border-top: none;
            }
         }
    }

    .store-intro {
        height: 130px;
        background: #ffffff;
        padding: 0 20px;
        box-sizing: border-box;
        border-top: 25px solid #fff;
        border-bottom: 25px solid #fff;

        .store-h {
            font-size: 32px;

            &.cloud-type:before {
                 content: '';
                 display: inline-block;
                 width: 48px;
                 height: 26px;
                 background: url("../assets/store-type-1.png") 0 0 no-repeat;
                 background-size: 48px 26px;
             }
            span {
                color: #ffaa00;
                font-size: 24px;
                margin-left: 25px;
                font-weight: normal;

                i {
                    color: #999;
                }
            }
        }

        .store-l {
            height: 100%;
            float: left;

            span.store-address {
                font-size: 26px;
                color: #999;
            }
        }

        .store-r {
            width: 110px;
            height: 100%;
            float: right;
            border-left: 1px solid #ddd;
            background: url("../assets/tel.png") center center no-repeat;
            background-size: 36px 38px;
            a {
                display: block;
                width: 100%;
                height: 100%;
            }
        }
    }

    .store-person {
        margin-top: 20px;
        padding: 20px 0 20px 24px;
        background: #fff;
        position: relative;
        box-sizing: border-box;
        overflow: hidden;

        > h2 {
              color: #333;
              font-size: 32px;
              text-align: center;
              font-weight: bold;
              height: 40px;
              margin-bottom: 30px;
              vertical-align: middle;
              line-height: 40px;

            &:before {
                width: 22px;
                height: 100%;
                vertical-align: middle;
                display: inline-block;
                content: '';
                background: url("../assets/icon-1.png") 0 0 no-repeat;
                background-size: 22px 36px;
                margin-right: 15px;
            }
        }

        .hd-scroll {
            overflow: hidden;
            position: relative;
            height: 445px;
        }

        .list-scroll {
            position: absolute;
        }

        ul {
            height: auto;
            overflow: hidden;
        }

        li {
            width: 335px;
            /*height: 525px;*/
            border: 1px solid #dcdcdc;
            border-radius: 10px;
            position: relative;
            margin-right: 15px;
            float: left;

            > h3 {
                  position: absolute;
                  background: #fa4b4b;
                  top: 10px;
                  padding: 4px 12px;
                  border-bottom-right-radius: 25px;
                  border-top-right-radius: 25px;
                  transform: scale(.9);
                  transform-origin: left center;
                  font-size: 22px;
                  color: #ffffff;
                  left: 0;
            }


            .list-l {
                margin: 20px auto 15px auto;
                width: 145px;
                height: 145px;

                img {
                    display: block;
                    overflow: hidden;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    border: 1px solid #ccc;
                }
            }

            .list-c {

                text-align: center;

                h4 {
                    color: #333;
                    font-size: 30px;
                }
                span.service {
                    font-size: 24px;
                    color: #999;
                    margin-bottom: 18px;
                    display: block;

                    i {
                        color: #ffaa00;
                    }
                }
                span.intro {
                    height: 100px;
                    color: #757575;
                    font-size: 24px;
                    display: block;
                    line-height: 1.4;
                    padding: 18px 25px;
                    position: relative;
                    background: #f5f5f5;

                    &:before {
                         display: block;
                         content: '';
                         position: absolute;
                         width: 0;
                         height: 0;
                         z-index: 1;
                         top: -18px;
                         left: 50%;
                         margin-left: -10px;
                         border-left: 10px solid transparent;
                         border-right: 10px solid transparent;
                         border-bottom: 18px solid #f5f5f5;
                     }
                }
            }

            .list-r {
                height: 60px;
                line-height: 60px;
                font-size: 32px;
                color: #ffffff;
                background: #ffaa00;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                text-align: center;

                a {
                    color: #ffffff;
                }
            }

        }


        /*只有一个导购的情况*/
        &.single {
            padding-right: 24px;

            li {
                width: 100%;
                height: 135px;
                border: none;

                h3 {
                    display: none;
                }

                .guideInfo:after {
                    display: block;
                    width: 96px;
                    height: 25px;
                    content: '';
                    background: url("../assets/type-1.png") 0 0 no-repeat;
                    background-size: 96px 25px;
                    bottom: 0px;
                    position: absolute;
                    left: 50%;
                    margin-left:-48px;
                }

                .list-l, .list-c, .list-r {
                    float: left;
                }

                .list-l {
                    margin-top: 0;
                    width: 130px;
                    height: 135px;
                    position: relative;
                    box-sizing: content-box;

                    img {
                        width: 130px;
                        height: 130px;
                    }
                }

                .list-c {
                    box-sizing: border-box;
                    padding-left: 15px;
                    height: 100%;
                    width: 440px;
                    padding-top: 15px;

                    .h-wrapper {
                        height: auto;
                        overflow: hidden;
                    }

                    h4 {
                        font-size: 30px;
                    }

                    h4, .service {
                        height: 45px;
                        line-height: 45px;
                        margin-left: 15px;
                        float: left;

                        i {
                            color: #ffaa00;
                        }
                    }

                    .intro {
                        background: #ffffff;
                        display: block;
                        padding: 0;
                        height: initial;
                        text-align: left;

                        &:before {
                            display: none;
                        }
                    }
                }

                .list-r {
                    width: 125px;
                    height: 100%;
                    position: relative;
                    background: #ffffff;

                    a {
                        display: block;
                        width: 100%;
                        height: 50px;
                        position: absolute;
                        line-height: 50px;
                        right: 0;
                        background: #ffaa00;
                        top: 50%;
                        margin-top: -25px;
                        border-radius: 5px;
                        font-size: 24px;
                    }
                }
            }

            .list-scroll {
                position: relative;
            }
        }
    }

    /*精彩活动*/
    .store-act {
        background: #fff;
        margin-top: 20px;
        padding: 20px 24px;

        > h2 {
            font-size: 32px;
            color: #333;
            text-align: center;
            font-weight: bold;
            height: 40px;
            vertical-align: middle;
            line-height: 40px;

            &:before {
                width: 35px;
                height: 100%;
                vertical-align: middle;
                display: inline-block;
                content: '';
                background: url("../assets/icon-2.png") 0 0 no-repeat;
                background-size: 35px 37px;
                margin-right: 15px;

            }
        }

        li {
            height: 200px;
            display: table;
            padding-top: 17px;

            &:nth-last-of-type(1) .store-r{

                 border: none;
            }

            .store-l {
                float: left;
                height: 165px;
                width: 268px;
                box-sizing: content-box;
                position: relative;
                border-right: 20px solid #fff;

                img {
                    display: block;
                    overflow: hidden;
                    width: 100%;
                    height: 100%;
                }

                span {
                    display: block;
                    width: 100%;
                    height: 38px;
                    line-height: 38px;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    text-align: center;
                    color: #ffffff;
                    font-size: 22px;
                    background: hsla(0, 0%, 0%, .6);
                }
            }
            .store-r {
                display: table-cell;
                vertical-align: middle;
                overflow: hidden;
                border-bottom: 1px dashed #dcdcdc;

                h2 {
                    width: 414px;
                    color: #333;
                    font-size: 30px;
                    font-weight: bold;
                    position: relative;

                    &.icon--1:before {
                        display: none;
                    }

                    &:before {
                        display: inline-block;
                         width: 48px;
                         height: 26px;
                         content: '';
                         margin-right: 10px;
                     }

                    @for $i from 0 to 7 {

                        &.icon-$(i):before {
                           background: url("../assets/act-type-$(i).png") 0 0 no-repeat;
                           background-size: 45px 25px;
                       }
                    }
                }

                span {
                    width: 414px;
                    font-size: 26px;
                    color: #999;
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    &:nth-last-of-type(1) {
                        margin-top: 20px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue